module.exports = __webpack_public_path__ + "static/favicon-0098ae6132adcbda8a8198dacc537992.ico";